import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import theme from '../../theme';


export const PopBox = styled(Box)({
  padding: '8px 0 8px',
  textAlign: 'center',
  backgroundColor: '#fff',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.grey.w100}`,
  boxShadow: `0px 2px 6px ${theme.palette.grey.w300}`
})

export const ArrowUpIn = styled('span')({
  zIndex: 800,
  position: 'absolute',
  top: '-24px',
  borderWidth: '14px',
  borderStyle: 'solid',
  borderColor: 'transparent transparent white transparent',
})

export const ArrowUpOut = styled('span')({
  zIndex: 500,
  position: 'absolute',
  top: '-25px',
  borderWidth: '14px',
  borderStyle: 'solid',
  borderColor: `transparent transparent ${theme.palette.grey.w100} transparent`,
})

export const ArrowRightUpIn = styled('span')({
  zIndex: 800,
  position: 'absolute',
  top: '-13px',
  right:'30px',
  borderWidth: '14px',
  borderStyle: 'solid',
  borderColor: 'transparent transparent white transparent',
})

export const ArrowRightUpOut = styled('span')({
  zIndex: 500,
  position: 'absolute',
  top: '-14px',
  right:'30px',
  borderWidth: '14px',
  borderStyle: 'solid',
  borderColor: `transparent transparent ${theme.palette.grey.w100} transparent`,
})

export const ModalPapper = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  minWidth: '340px',
  maxWidth: '1000px',
  textAlign: 'center',
  backgroundColor: '#FFF',
  borderRadius: '10px',
  boxShadow: 24,
  transform: 'translate(-50%, -50%)',

  '&:focus-visible': {
    outline: 'none'
  }
})